import { registerCustomDetailComponent } from '@vendure/admin-ui/core';

// Components
import { CustomerPaymentMethodsComponent } from './components/custom.details/custom.details.components'

export default [
    registerCustomDetailComponent({
        locationId: 'customer-detail',
        component: CustomerPaymentMethodsComponent,
    })
];